import { Route, Routes } from "react-router-dom";

import PriceRemarkPending from "./list";
import PriceRemarkPendingStore from "./store";

export default function PriceRemarkPendingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PriceRemarkPending />} />
      <Route path="/loja/:codigo" element={<PriceRemarkPendingStore />} />
    </Routes>
  );
}
